import React from "react";

const Svg = ({width = 178}: {width?: number} = {}) => {
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 178 178"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M89 0C138.153 0 178 39.8467 178 89C178 138.153 138.153 178 89 178C39.8467 178 0 138.153 0 89C0 39.8467 39.8467 0 89 0ZM89 27C54.7583 27 27 54.7583 27 89C27 123.242 54.7583 151 89 151C123.242 151 151 123.242 151 89C151 54.7583 123.242 27 89 27Z"
        fill="#D9D9D9"
      />
      <path
        d="M89 0C138.153 0 178 39.8467 178 89C178 138.153 138.153 178 89 178C39.8467 178 0 138.153 0 89H27C27 123.242 54.7583 151 89 151C123.242 151 151 123.242 151 89C151 54.7583 123.242 27 89 27V0Z"
        fill="#668DFF"
      />
    </svg>
  );
};
export default Svg;
